import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from '@material-ui/core'
import React from 'react'
import { COLORS } from '../../constants'

export interface ConfirmationDialogProps extends Omit<DialogProps, 'open'> {
  attachState: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
  title?: string
  renderBeforeOpen?: boolean
  cancelBtnText?: string
  confirmBtnText?: string
  closeOnCancel?: boolean
  closeOnConfirm?: boolean
  onCancel?: () => void
  onConfirm: () => void
}

export default function ConfirmationDialog({
  attachState,
  title,
  renderBeforeOpen = false,
  cancelBtnText = 'cancel',
  confirmBtnText = 'confirm',
  closeOnCancel = true,
  closeOnConfirm = true,
  onCancel,
  onConfirm,
  children,
  ...dialogProps
}: ConfirmationDialogProps) {
  const [open, setOpen] = attachState

  const handleCancel = () => {
    if (closeOnCancel) {
      setOpen(false)
    }
    onCancel?.()
  }

  const handleConfirm = () => {
    if (closeOnConfirm) {
      setOpen(false)
    }
    onConfirm()
  }

  if (renderBeforeOpen && !open) {
    return null
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} {...dialogProps}>
      {title && <DialogTitle>{title}</DialogTitle>}

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        <Button onClick={handleCancel}>{cancelBtnText}</Button>

        <Button onClick={handleConfirm} style={{ color: COLORS.dangerRed }}>
          {confirmBtnText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
